import {
  AlertDialog as ChakraAlertDialog,
  AlertDialogProps as ChakraAlertDialogProps,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type AlertDialogProps = OmitChakraProps<
  ChakraAlertDialogProps,
  'colorScheme' | 'variant' | 'orientation' | 'styleConfig'
>;

export const AlertDialog = ({
  isCentered = true,
  ...props
}: AlertDialogProps) => (
  <ChakraAlertDialog isCentered={isCentered} {...props} />
);
